const images = [

    {
        'name': 'hero',
        'scope': 'demo',
        'source': require('./demo/hero.png'),
        'type': 'image'
    },
    {
        'name': 'city',
        'scope': 'demo',
        'source': require('./demo/city.png'),
        'type': 'image'
    },
    {
        'name': 'chronometer',
        'scope': 'demo',
        'source': require('./demo/chronometer.png'),
        'type': 'image'
    },
    {
        'name': 'box',
        'scope': 'demo',
        'source': require('./demo/box.png'),
        'type': 'image'
    },
    {
        'name': 'boxfront',
        'scope': 'demo',
        'source': require('./demo/box-front.png'),
        'type': 'image'
    },
    {
        'name': 'enemy',
        'scope': 'demo',
        'source': require('./demo/enemy.png'),
        'type': 'image'
    },
    {
        'name': 'hit',
        'scope': 'demo',
        'source': require('./demo/hit.png'),
        'type': 'image'
    },
    {
        'name': 'cloud',
        'scope': 'demo',
        'source': require('./demo/cloud.png'),
        'type': 'image'
    },
    {
        'name': 'timeline',
        'scope': 'demo',
        'source': require('./demo/timeline.png'),
        'type': 'image'
    },
    {
        'name': 'heart',
        'scope': 'demo',
        'source': require('./demo/heart.png'),
        'type': 'image'
    },
    {
        'name': 'timelineback',
        'scope': 'demo',
        'source': require('./demo/timeline-back.png'),
        'type': 'image'
    },
    {
        'name': 'card',
        'scope': 'demo',
        'source': require('./demo/card.png'),
        'type': 'image'
    },
    {
        'name': 'carrot',
        'scope': 'demo',
        'source': require('./demo/carrot.png'),
        'type': 'image'
    },
    {
        'name': 'tomato',
        'scope': 'demo',
        'source': require('./demo/tomato.png'),
        'type': 'image'
    },
    {
        'name': 'chick',
        'scope': 'demo',
        'source': require('./demo/chick.png'),
        'type': 'image'
    },
    {
        'name': 'burger',
        'scope': 'demo',
        'source': require('./demo/burger.png'),
        'type': 'image'
    },
    {
        'name': 'wine',
        'scope': 'demo',
        'source': require('./demo/wine.png'),
        'type': 'image'
    },
    {
        'name': 'drug',
        'scope': 'demo',
        'source': require('./demo/drug.png'),
        'type': 'image'
    },
    {
        'name': 'plane',
        'scope': 'demo',
        'source': require('./demo/plane.png'),
        'type': 'image'
    },
    {
        'name': 'gun',
        'scope': 'demo',
        'source': require('./demo/gun.png'),
        'type': 'image'
    }
];

export {images};
